<template>
	<button class="user_list_item" ref="item_frame" v-show="!isShowRegistHService"
		@keydown.enter.prevent="action_SelectService" @click="action_SelectService">
		<span class="name">{{ name }}</span>
		<span v-if="isHService == true && usingChartNumber" class="chartnum">({{ chartNumber }})</span>
		<span v-if="isHService == true" class="gen_birth">{{ birthGender }}</span>
		<span v-if="isHService == true" class="phonenum"><v-icon x-small>mdi-cellphone</v-icon>{{ phoneNumber }}</span>
		<span v-show="isReservationOnly == true" class="btn_etc">{{ $t('reservationwindow.searchresults.label_reservationonly') }}</span>
		<span v-show="isNewHService == true" class="btn_etc">{{ $t('reservationwindow.searchresults.label_reservationwithregist') }}</span>
	</button>
</template>


<script>
import { formatGenderShort } from '@/util/format-gender'
import { formatPhoneHyphen } from '@/util/format-phone'
import { toBirth6String } from '@/util/format-birth'
import { mapState } from "vuex";
import moment from '@/util/MPMoment'

export default {
	props: {
		service: Object,
		focusedService: Object,
		isShowRegistHService: Boolean,
	},
	watch: {
		isSelected: {
			deep: true,
			immediate: true,
			handler: function (newValue) {
				if (newValue == true) {
					let el = this.$refs["item_frame"];
					if (el != undefined) {
						el.focus();
					}
				}
			},
		},
	},
	computed: {
		...mapState(["SaaS"]),

		isWindow: function () {
			return this.SaaS?.isWindow ?? false;
		},
		isSelected: function () {
			return this.service == this.focusedService;
		},
		usingChartNumber: function () {
			return this.servicesetting?.setting?.usingChartNumber ?? false;
		},
		name: function () {
			return this.service?.name;
		},
		chartNumber: function () {
			return this.service?.chartNumber;
		},
		gender: function () {
			const gender = formatGenderShort(this.service?.gender);

			if (gender === '남') {
				return this.$t('common.male_short')
			}

			if (gender === '여') {
				return this.$t('common.female_short')
			}

			return '-';
		},
		birth: function () {
			const birth = this.service?.birth;

			if (birth === undefined || birth === null || birth === '') {
				return "-";
			}

			const date = moment(birth);

			if (date.isValid()) {
				return date.format(this.$t('common.date_format_YYMMDD'));
			}

			return toBirth6String(birth) ?? "-";
		},
		birthGender: function () {
			return this.gender + "/" + this.birth;
		},
		countries: function () {
			const list = this.$store.state.servicesetting.countries;
			return Array.isArray(list) ? list : [];
		},
		countryCodeId: function () {
			// KR fallback 을 두지 않는다 — 국가코드가 없으면 접두 없이 국내 포맷으로 표시 (기존 동작)
			return this.service?.countryCode?._id;
		},
		countryDialingCode: function () {
			if (!this.isWindow) return "";

			const code = this.service?.countryCode?.internationalDialingCodes;
			if (code) {
				return `(+${code})`;
			}

			// 국가 목록 API 는 _id 를 countryId 로 리네임해 내려준다
			const country = this.countries.find(c => c.countryId == this.countryCodeId);
			if (country) {
				return `(+${country.internationalDialingCodes})`;
			}
			return "";
		},
		phoneNumber: function () {
			const phoneRaw = this.service?.phone;
			if (!phoneRaw) return "-";

			if (this.countryDialingCode) {
				return `${this.countryDialingCode} ${phoneRaw}`;
			}
			return formatPhoneHyphen(phoneRaw) || "-";
		},
		isHService: function () {
			return !(this.isReservationOnly == true || this.isNewHService == true);
		},
		isReservationOnly: function () {
			return this.service?.isUnregisteredUser ?? false;
		},
		isNewHService: function () {
			return this.service?.isNewHService ?? false;
		},
	},
	methods: {
		action_SelectService() {
			this.$emit("setSelectedService", this.service);
		},
	},
};
</script>